export default "__VITE_ASSET__CcjUyfe8__"